import React from 'react';
import { Modal } from 'antd';
import { ShoppingCartRemoveModalProps } from '../interfaces';

const ShoppingCartRemoveModal: React.FC<ShoppingCartRemoveModalProps> = ({
  open,
  productTitle,
  onConfirm,
  onCancel,
}) => (
  <Modal
    title="Remove this item?"
    open={open}
    okText="Remove"
    okType="danger"
    cancelText="Cancel"
    onOk={onConfirm}
    onCancel={onCancel}
  >
    <p>{productTitle} will be removed from your cart.</p>
  </Modal>
);

export default React.memo(ShoppingCartRemoveModal);
